import { AssetAllocationStore } from '.';
import { RootState } from '../..';

export const selectAssetAllocation = (state: RootState): AssetAllocationStore => state.assetAllocation;
